import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";
import { icons_data, iconsPromise } from "../PropertyComponents/IconData";

const IconComponent = ({ icon }) => {
  const [loadedIcons, setLoadedIcons] = useState(icons_data);
  useEffect(() => {
    if (icons_data.length === 0) {
      iconsPromise
        .then((fetchedIcons) => {
          setLoadedIcons(fetchedIcons);
        })
        .catch((error) => {
          console.error("Failed to load icons:", error);
        });
    }
  }, []);
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = icon.id === hoveredDivision;
  const [isIconHovered, setIsIconHovered] = useState(false);
  const [isIconFocused, setIsIconFocused] = useState(false);
  const [isIconActive, setIsIconActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = icon;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = icon;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = icon;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = icon;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (icon.backgroundImage && icon.backgroundImage.startsWith("./")) {
        const imageName = icon.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(icon.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [icon.backgroundImage, files]);

  const focusedStyles =
    isIconFocused && icon.pseudoClass === "focus"
      ? {
          fontSize: icon.focusedfontSize || icon.fontSize || "inherit",
          width: icon.focusedwidth || "fit-content",
          height: icon.focusedheight || "fit-content",

          padding: icon.focusedpadding || icon.padding || "0",
          paddingTop: icon.focusedpaddingTop || icon.focusedpadding || "0",
          paddingRight: icon.focusedpaddingRight || icon.focusedpadding || "0",
          paddingBottom:
            icon.focusedpaddingBottom || icon.focusedpadding || "0",
          paddingLeft: icon.focusedpaddingLeft || icon.focusedpadding || "0",
          margin: icon.focusedmargin || icon.margin || "0px",
          marginTop: icon.focusedmarginTop || icon.focusedmargin || "0px",
          marginRight: icon.focusedmarginRight || icon.focusedmargin || "0px",
          marginBottom: icon.focusedmarginBottom || icon.focusedmargin || "0px",
          marginLeft: icon.focusedmarginLeft || icon.focusedmargin || "0px",

          borderTop:
            icon.focusedborderTop ||
            icon.focusedborder ||
            icon.border ||
            "none",
          borderRight:
            icon.focusedborderRight ||
            icon.focusedborder ||
            icon.border ||
            "none",
          borderBottom:
            icon.focusedborderBottom ||
            icon.focusedborder ||
            icon.border ||
            "none",
          borderLeft:
            icon.focusedborderLeft ||
            icon.focusedborder ||
            icon.border ||
            "none",
          borderSapcing:
            icon.focusedborderSpacing || icon.borderSpacing || "0px",
          borderCollapse:
            icon.focusedborderCollapse || icon.borderCollapse || "0px",
          borderRadius: icon.focusedborderRadius || icon.borderRadius || "0",
          outline: icon.focusedoutline || icon.outline || "none",

          position: icon.focusedposition || icon.position || "relative",
          top: icon.focusedtop || icon.top || "auto",
          right: icon.focusedright || icon.right || "auto",
          bottom: icon.focusedbottom || icon.bottom || "auto",
          left: icon.focusedleft || icon.left || "auto",
          zIndex: icon.focusedzIndex || icon.zIndex || "auto",

          boxShadow: icon.focusedboxShadow || icon.boxShadow || "none",
          opacity: icon.focusedOpacity || icon.opacity || 1,
          color: icon.focusedcolor || icon.color || "#000000",
          backgroundColor:
            icon.focusedbackgroundColor || icon.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (icon.focusedbackgroundImage) {
              if (icon.focusedbackgroundImage.startsWith("./")) {
                const imageName = icon.focusedbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.focusedbackgroundImage})`;
            }
            if (icon.backgroundImage) {
              if (icon.backgroundImage.startsWith("./")) {
                const imageName = icon.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            icon.focusedbackgroundPosition ||
            icon.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            icon.focusedbackgroundSize || icon.backgroundSize || "auto",
          backgroundRepeat:
            icon.focusedbackgroundRepeat || icon.backgroundRepeat || "repeat",
          backgroundAttachment:
            icon.focusedbackgroundAttachment ||
            icon.backgroundAttachment ||
            "scroll",

          display: icon.focuseddisplay || icon.display || "block",
          visibility: icon.focusedvisibility || "visible",
          cursor: icon.focusedcursor || icon.cursor || "default",

          transform: icon.focusedtransform || icon.transform || "none",
          transition: icon.focusedtransition || icon.transition || "none",
        }
      : {};

  const hoverStyles =
    isIconHovered && icon.pseudoClass === "hover"
      ? {
          fontSize: icon.hoveredfontSize || icon.fontSize || "inherit",
          width: icon.hoveredwidth || "fit-content",
          height: icon.hoveredheight || "fit-content",

          padding: icon.hoveredpadding || icon.padding || "0",
          paddingTop: icon.hoveredpaddingTop || icon.hoveredpadding || "0",
          paddingRight: icon.hoveredpaddingRight || icon.hoveredpadding || "0",
          paddingBottom:
            icon.hoveredpaddingBottom || icon.hoveredpadding || "0",
          paddingLeft: icon.hoveredpaddingLeft || icon.hoveredpadding || "0",
          margin: icon.hoveredmargin || icon.margin || "0px",
          marginTop: icon.hoveredmarginTop || icon.hoveredmargin || "0px",
          marginRight: icon.hoveredmarginRight || icon.hoveredmargin || "0px",
          marginBottom: icon.hoveredmarginBottom || icon.hoveredmargin || "0px",
          marginLeft: icon.hoveredmarginLeft || icon.hoveredmargin || "0px",

          borderTop:
            icon.hoveredborderTop ||
            icon.hoveredborder ||
            icon.border ||
            "none",
          borderRight:
            icon.hoveredborderRight ||
            icon.hoveredborder ||
            icon.border ||
            "none",
          borderBottom:
            icon.hoveredborderBottom ||
            icon.hoveredborder ||
            icon.border ||
            "none",
          borderLeft:
            icon.hoveredborderLeft ||
            icon.hoveredborder ||
            icon.border ||
            "none",
          borderSapcing:
            icon.hoveredborderSpacing || icon.borderSpacing || "0px",
          borderCollapse:
            icon.hoveredborderCollapse || icon.borderCollapse || "0px",
          borderRadius: icon.hoveredborderRadius || icon.borderRadius || "0",
          outline: icon.hoveredoutline || icon.outline || "none",

          position: icon.hoveredposition || icon.position || "relative",
          top: icon.hoveredtop || icon.top || "auto",
          right: icon.hoveredright || icon.right || "auto",
          bottom: icon.hoveredbottom || icon.bottom || "auto",
          left: icon.hoveredleft || icon.left || "auto",
          zIndex: icon.hoveredzIndex || icon.zIndex || "auto",

          boxShadow: icon.hoveredboxShadow || icon.boxShadow || "none",
          opacity: icon.hoveredOpacity || icon.opacity || 1,
          color: icon.hoveredcolor || icon.color || "#000000",
          backgroundColor:
            icon.hoveredbackgroundColor || icon.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (icon.hoveredbackgroundImage) {
              if (icon.hoveredbackgroundImage.startsWith("./")) {
                const imageName = icon.hoveredbackgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.hoveredbackgroundImage})`;
            }
            if (icon.backgroundImage) {
              if (icon.backgroundImage.startsWith("./")) {
                const imageName = icon.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            icon.hoveredbackgroundPosition ||
            icon.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            icon.hoveredbackgroundSize || icon.backgroundSize || "auto",
          backgroundRepeat:
            icon.hoveredbackgroundRepeat || icon.backgroundRepeat || "repeat",
          backgroundAttachment:
            icon.hoveredbackgroundAttachment ||
            icon.backgroundAttachment ||
            "scroll",

          display: icon.hovereddisplay || icon.display || "block",
          visibility: icon.hoveredvisibility || "visible",
          cursor: icon.hoveredcursor || icon.cursor || "default",

          transform: icon.hoveredtransform || icon.transform || "none",
          transition: icon.hoveredtransition || icon.transition || "none",
        }
      : {};

  const activeStyles =
    isIconActive && icon.pseudoClass === "active"
      ? {
          fontSize: icon.activatedfontSize || icon.fontSize || "inherit",
          width: icon.activatedwidth || "fit-content",
          height: icon.activatedheight || "fit-content",

          padding: icon.activatedpadding || icon.padding || "0",
          paddingTop: icon.activatedpaddingTop || icon.activatedpadding || "0",
          paddingRight:
            icon.activatedpaddingRight || icon.activatedpadding || "0",
          paddingBottom:
            icon.activatedpaddingBottom || icon.activatedpadding || "0",
          paddingLeft:
            icon.activatedpaddingLeft || icon.activatedpadding || "0",
          margin: icon.activatedmargin || icon.margin || "0px",
          marginTop: icon.activatedmarginTop || icon.activatedmargin || "0px",
          marginRight:
            icon.activatedmarginRight || icon.activatedmargin || "0px",
          marginBottom:
            icon.activatedmarginBottom || icon.activatedmargin || "0px",
          marginLeft: icon.activatedmarginLeft || icon.activatedmargin || "0px",

          borderTop:
            icon.activatedborderTop ||
            icon.activatedborder ||
            icon.border ||
            "none",
          borderRight:
            icon.activatedborderRight ||
            icon.activatedborder ||
            icon.border ||
            "none",
          borderBottom:
            icon.activatedborderBottom ||
            icon.activatedborder ||
            icon.border ||
            "none",
          borderLeft:
            icon.activatedborderLeft ||
            icon.activatedborder ||
            icon.border ||
            "none",
          borderSapcing:
            icon.activatedborderSpacing || icon.borderSpacing || "0px",
          borderCollapse:
            icon.activatedborderCollapse || icon.borderCollapse || "0px",
          borderRadius: icon.activatedborderRadius || icon.borderRadius || "0",
          outline: icon.activatedoutline || icon.outline || "none",

          position: icon.activatedposition || icon.position || "relative",
          top: icon.activatedtop || icon.top || "auto",
          right: icon.activatedright || icon.right || "auto",
          bottom: icon.activatedbottom || icon.bottom || "auto",
          left: icon.activatedleft || icon.left || "auto",
          zIndex: icon.activatedzIndex || icon.zIndex || "auto",

          boxShadow: icon.activatedboxShadow || icon.boxShadow || "none",
          opacity: icon.activatedOpacity || icon.opacity || 1,
          color: icon.activatedcolor || icon.color || "#000000",
          backgroundColor:
            icon.activatedbackgroundColor || icon.backgroundColor || "#ffffff",
          backgroundImage: (() => {
            if (icon.activatedbackgroundImage) {
              if (icon.activatedbackgroundImage.startsWith("./")) {
                const imageName = icon.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.activatedbackgroundImage})`;
            }
            if (icon.backgroundImage) {
              if (icon.backgroundImage.startsWith("./")) {
                const imageName = icon.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${icon.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            icon.activatedbackgroundPosition ||
            icon.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            icon.activatedbackgroundSize || icon.backgroundSize || "auto",
          backgroundRepeat:
            icon.activatedbackgroundRepeat || icon.backgroundRepeat || "repeat",
          backgroundAttachment:
            icon.activatedbackgroundAttachment ||
            icon.backgroundAttachment ||
            "scroll",

          display: icon.activateddisplay || icon.display || "block",
          cursor: icon.activatedcursor || icon.cursor || "default",
          visibility: icon.activatedvisibility || "visible",

          transform: icon.activatedtransform || icon.transform || "none",
          transition: icon.activatedtransition || icon.transition || "none",
        }
      : {};

  const iconStyle = {
    fontSize: icon.fontSize || "1rem",
    width: icon.width || "100%",
    height: icon.height || "auto",

    margin: icon.margin || "0px",
    marginTop: icon.marginTop || icon.margin || "0",
    marginRight: icon.marginRight || icon.margin || "0px",
    marginBottom: icon.marginBottom || icon.margin || "0",
    marginLeft: icon.marginLeft || icon.margin || "0",
    padding: icon.padding || "0px",
    paddingTop: icon.paddingTop || icon.padding || "0",
    paddingRight: icon.paddingRight || icon.padding || "0",
    paddingBottom: icon.paddingBottom || icon.padding || "0",
    paddingLeft: icon.paddingLeft || icon.padding || "0",

    borderTop: icon.borderTop || icon.border || "none",
    borderRight: icon.borderRight || icon.border || "none",
    borderBottom: icon.borderBottom || icon.border || "none",
    borderLeft: icon.borderLeft || icon.border || "none",

    borderSapcing: icon.borderSpacing || "0px",
    borderCollapse: icon.borderCollapse || "0px",
    borderRadius: icon.borderRadius || "0",
    outline: icon.outline || "none",

    position: icon.position || "static",
    top: icon.top || "auto",
    right: icon.right || "auto",
    bottom: icon.bottom || "auto",
    left: icon.left || "auto",
    zIndex: icon.zIndex || "auto",

    color: icon.color || "#000000",
    backgroundColor: icon.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundSize: icon.backgroundSize || "auto",
    backgroundPosition: icon.backgroundPosition || "0% 0%",
    backgroundRepeat: icon.backgroundRepeat || "repeat",
    backgroundAttachment: icon.backgroundAttachment || "scroll",

    opacity: icon.opacity || "1",
    display: icon.display || "block",
    visibility: icon.visibility || "visible",
    boxShadow: icon.boxShadow || "none",
    cursor: icon.cursor || "auto",

    scale: isHovered ? "1.  1" : "1",

    transform: icon.transform || "none",
    transition: icon.transition || "ease .3s",

    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const findIconByName = (iconName) => {
    const lowerCaseIconName = iconName.toLowerCase();
    return (
      loadedIcons.find(
        (ic) => ic.icon_name.toLowerCase() === lowerCaseIconName
      ) || null
    );
  };

  let iconData = {
    class: "fa-solid fa-icons",
    icon_name: "icon",
    cdn_name: "FontAwesome",
  };

  if (icon.iconName) {
    iconData = findIconByName(icon.iconName);
  }
  return (
    <i
      className={iconData.class}
      style={iconStyle}
      onMouseEnter={() => setIsIconHovered(true)}
      onMouseLeave={() => setIsIconHovered(false)}
      onFocus={() => setIsIconFocused(true)}
      onBlur={() => setIsIconFocused(false)}
      onMouseDown={() => setIsIconActive(true)}
      onMouseUp={() => setIsIconActive(false)}
    ></i>
  );
};

export default IconComponent;
